import { Select, SelectProps } from '@creditornot/cb-select';
import React from 'react';
import { useIntl } from 'react-intl';

import { Role } from 'apis/restaurant-api/merchant-admin/venue/types';

const roleOptions: { id: string; value: Role }[] = [
  {
    id: 'userManagement.storeManagerRole',
    value: 'store_manager',
  },
  {
    id: 'userManagement.pickerRole',
    value: 'picker',
  },
  {
    id: 'userManagement.storeStaffExtended',
    value: 'store_staff_extended',
  },
];

const roles: Role[] = ['store_manager', 'picker', 'store_staff_extended'];

export const isRole = (data: any): data is Role => roles.includes(data);

const RoleSelect = (props: Partial<SelectProps<{ label: string; value: Role }>>) => {
  const intl = useIntl();
  return (
    <Select
      options={roleOptions.map(roleOption => ({
        label: intl.formatMessage({ id: roleOption.id }),
        value: roleOption.value,
      }))}
      placeholder={intl.formatMessage({ id: 'userManagement.userRightsPlaceholder' })}
      {...props}
    />
  );
};

export default RoleSelect;
